<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	let className = '';
	export { className as class };
	export let name = '';
	export let value = '';
	export let placeholder = '';
	export let required = false;
	export let id = '';
</script>

<input
	type="password"
	{id}
	{placeholder}
	{required}
	{name}
	{value}
	class={twMerge(
		'border-1 block w-full rounded-sm border-secondary-300 bg-secondary-50 px-3 py-2 font-mundial-light text-sm font-light text-gray-800 focus:border-secondary-500 focus:shadow-none focus:outline-none focus:ring-0',
		className
	)}
/>
